'use client'
import { H1, Table, TableRow, TableHeader, TableCell, SmartLink, ColorButton } from "@/components/ui";
import { File, Folder } from "@/assets/icons";
import { useFTP } from "@/hooks/useFTP";
import { RouteType } from "@/types";

interface ManageClientsProps {
    routeType?: RouteType;
}
export function ManageClientBackups({ routeType = 'BACKUP' }: ManageClientsProps) {
    const { contents, isLoading, error } = useFTP(routeType);
    return (
        <div>
            <H1>Clientes</H1>
            <p>Selecione um cliente para baixar arquivos</p>

            {error &&
                <div className="error-message">
                    {error}
                </div>
            }
            <div className="p-8 pt-8 hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader colSpan={2}></TableHeader>
                            <TableHeader>Cliente</TableHeader>
                            <TableHeader>Selecionar Cliente</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={4} className="text-center py-8">
                                    Carregando...
                                </TableCell>
                            </TableRow>
                        ) : contents.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={4} className="text-center py-8">
                                    Diretório vazio
                                </TableCell>
                            </TableRow>
                        ) : (
                            contents.map((item, index) => (
                                <TableRow key={`${item.name}-${index}`}>
                                    <TableCell colSpan={2}>
                                        {(item.type === 'directory') ? <Folder /> : <File />}

                                    </TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>
                                        <SmartLink
                                            type={"internal"}
                                            route={"adminViewClientBackups"}
                                            params={[encodeURIComponent(item.name)]}>
                                            <ColorButton onClick={() => {
                                                localStorage.setItem('ftpRouteType', routeType);
                                            }}
                                            >
                                                Visualizar arquivos
                                            </ColorButton>
                                        </SmartLink>
                                    </TableCell>

                                </TableRow>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

            <div className="p-8 flex md:hidden">
                <Table>
                    <tbody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell className="text-center py-8">
                                    Carregando...
                                </TableCell>
                            </TableRow>
                        ) : contents.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center py-8">
                                    Diretório vazio
                                </TableCell>
                            </TableRow>
                        ) : (
                            contents.map((item, index) => (
                                <TableRow key={`${item.name}-${index}`}>
                                    <TableCell>
                                        {(item.type === 'directory') ? <Folder /> : <File />}

                                    </TableCell>
                                    <TableHeader>Cliente</TableHeader>
                                    <TableCell>{item.name}</TableCell>
                                    <TableHeader>Selecionar Cliente</TableHeader>
                                    <TableCell>
                                        <SmartLink
                                            type={"internal"}
                                            route={"adminViewClientBackups"}
                                            params={[encodeURIComponent(item.name)]}>
                                            <ColorButton onClick={() => {
                                                localStorage.setItem('ftpRouteType', routeType);
                                            }}
                                            >
                                                Visualizar arquivos
                                            </ColorButton>
                                        </SmartLink>
                                    </TableCell>

                                </TableRow>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}